module.exports = __webpack_public_path__ + "img/ics_o_calendar.20f85493.svg";